import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import bannerSecond from '../../assets/banner_second.jpg';
import { getDeviceType } from '../../utils/common';
import { pageAction } from '../../redux_files/actions/page_actions';

const TraditionalIndianFood = () => {
	const dispatch = useDispatch();
	const [deviceType, setDeviceType] = useState(getDeviceType());
	useEffect(() => {
		window.addEventListener('resize', setDeviceType(getDeviceType()));
		return () => window.removeEventListener('resize', setDeviceType(getDeviceType()));
	}, []);

	useEffect(() => {
		document.title = 'Blogs | Traditional Indian Meals That Never Go Out of Style';
		dispatch(pageAction('Traditional Indian Meals'));
	});
	return (
		<>
			<img src={bannerSecond} alt='Banner' width='100%' height={deviceType !== "mobile" ? "480" : "200"} />
			<div className='container'>

				<article>
					{deviceType === "mobile" ? <h3>🍽️ Traditional Indian Meals That Never Go Out of Style</h3> : <h2>🍽️ Traditional Indian Meals That Never Go Out of Style</h2>}

					<p>India’s culinary heritage is a celebration of time-tested recipes passed down through generations. In a world of fast food and fusion trends, some meals remain eternal favorites—bringing comfort, nutrition, and nostalgia to the table.</p>

					<b>🥘 1. Dal Chawal (Lentils & Rice)</b>
					<p>Simple, soulful, and satisfying. A plate of hot dal over steamed rice is the ultimate Indian comfort food.</p>
					<p><strong>💡 Tip:</strong> Add a dollop of ghee or pair with papad or pickle for regional flair.</p>

					<b>🍛 2. Rajma Chawal (Kidney Beans Curry with Rice)</b>
					<p>A North Indian staple that’s as hearty as it is flavorful. Rich, spiced rajma with fluffy rice is a favorite among students and families alike.</p>

					<b>🍲 3. Khichdi</b>
					<p>The one-pot wonder of Indian homes. Made with rice and lentils, khichdi is easy on the stomach and perfect for busy days or recovery meals.</p>
					<p><strong>✨ Comfort add-ons:</strong> Ghee, papad, or mango pickle.</p>

					<b>🫓 4. Roti Sabzi (Indian Flatbread with Vegetables)</b>
					<p>Whether it’s aloo gobi, bhindi masala, or baingan bharta, roti with sabzi is a daily staple. Healthy, high in fiber, and easy to customize with seasonal veggies.</p>

					<b>❤️ Why These Meals Last</b>
					<p>
						• Rooted in tradition and family culture<br />
						• Prepared with everyday, wholesome ingredients<br />
						• Balanced meals rich in carbs, protein, and fiber<br />
						• Deep emotional connection and nostalgic value
					</p>

					<hr />

					<b>📦 Final Word: Meals with Purpose</b>
					<p>At Shivay Durga Foods, we blend tradition, nutrition, and convenience—especially for students. Whether you`re looking for a quick bite or a comforting thali, we`re here to serve food that <strong>feels like home</strong>.</p>

					<p><strong>Order now</strong> and taste the difference.</p>
				</article>
			</div>
		</>
	);
};
export default TraditionalIndianFood;
